import React from 'react';
import dayjs from 'dayjs';
import { getI18n } from 'react-i18next';
import { ColumnsType } from 'antd/lib/table';
import TableHeader from '~/pages/agent/components/agent/tableElements/TableHeader';

function submittedCell(): ColumnsType<any>[0] {
  return {
    title: () => (
      <TableHeader title={getI18n().t('Submitted', { ns: 'agent' })} sortingDataKey="submitted" />
    ),
    dataIndex: 'submitted',
    key: 'submitted',
    render: (date?: string) =>
      date ? <span key={date}>{dayjs(date).format('DD/MM/YYYY')}</span> : null,
    width: 120,
  };
}

export default submittedCell;
